import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { updateSelectedFilters } from 'store/actions/filters'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'
import FilterTitle from 'components/ui/FilterTitle'

function ArrayMultiSelectHigherLevel({
  type,
  macroType,
  filterData,
  values,
  selection,
  showFilter,
  customTop,
  title
}) {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const selectedValues = macroType
    ? filters.selectedFilters[currentSearchable][macroType][type]
    : filters.selectedFilters[currentSearchable][type]
  const options = filterData.map(option => {
    const parentOption = {
      label: option,
      value: option,
      expanded: true
    }
    const selectedOption = selectedValues.filter(s => s === option)
    if (selectedOption.length > 0) {
      parentOption.checked = true
    }
    return parentOption
  })

  const onChange = (currentNode, selectedNodes) => {
    const filterValue = selectedNodes.map(node => node.label)

    const data = {
      filterType: type,
      filterMacroType: macroType,
      filterId: type,
      filterValue,
      isHigherLevelFilter: true
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
    let resultingValue = null
    if (valueIsArray) {
      resultingValue = selectedValues.filter(s => s !== filterValue)
    }
    const data = {
      filterType: type,
      filterMacroType: macroType,
      filterId,
      filterValue: resultingValue,
      isHigherLevelFilter: true
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (selectedValues) {
        const filterValue = selectedValues
        if (filterValue instanceof Array) {
          return filterValue.map(v => (
            <SelectedFilterContainer className="selected-filters" key={v.id ? v.id : v}>
              <SelectedFilter>
                <FilterText title={v.label ? v.label : v}>
                  <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{v.label ? v.label : v}</Dotdotdot>
                </FilterText>
                <RemoveIcon
                  className="far fa-times"
                  onClick={() => handleFilterRemove(value, v, true)}
                />
              </SelectedFilter>
            </SelectedFilterContainer>
          ))
        }
      }
      return false
    })
  }

  return (
    <>
      {!selection ? (
        <SearchFilter open={showFilter} customTop={customTop}>
          <div className="sticky-container">
            {title ? <FilterTitle>{title}</FilterTitle> : null}
            <CustomDropDownTreeSelect data={options} onChange={onChange} />
          </div>
        </SearchFilter>
      ) : (
        <div className="selected-fl">{renderSelectedValues()}</div>
      )}
    </>
  )
}

ArrayMultiSelectHigherLevel.propTypes = {
  type: PropTypes.string,
  macroType: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  selection: PropTypes.bool,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string
}

export default ArrayMultiSelectHigherLevel
